import { render, staticRenderFns } from "./AndroidKioskLifecycle.vue?vue&type=template&id=fcb17f58&scoped=true"
import script from "./AndroidKioskLifecycle.vue?vue&type=script&lang=js"
export * from "./AndroidKioskLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb17f58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcb17f58')) {
      api.createRecord('fcb17f58', component.options)
    } else {
      api.reload('fcb17f58', component.options)
    }
    module.hot.accept("./AndroidKioskLifecycle.vue?vue&type=template&id=fcb17f58&scoped=true", function () {
      api.rerender('fcb17f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/androidkiosk/AndroidKioskLifecycle.vue"
export default component.exports